import { useEffect, useState } from 'react';

const LOGICAL_W = 480;
const LOGICAL_H = 270;

export interface ViewportFit {
  cssWidth: number;
  cssHeight: number;
  isPortrait: boolean;
}

export function useViewportFit(maxCssWidth = 960): ViewportFit {
  const [fit, setFit] = useState<ViewportFit>(() => compute(maxCssWidth));
  useEffect(() => {
    const onResize = () => setFit(compute(maxCssWidth));
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, [maxCssWidth]);
  return fit;
}

function compute(maxCssWidth: number): ViewportFit {
  if (typeof window === 'undefined') {
    return { cssWidth: maxCssWidth, cssHeight: maxCssWidth * (LOGICAL_H / LOGICAL_W), isPortrait: false };
  }
  const vw = Math.min(window.innerWidth - 16, maxCssWidth);
  const isPortrait = window.innerWidth < window.innerHeight;
  const cssWidth = vw;
  const cssHeight = vw * (LOGICAL_H / LOGICAL_W);
  return { cssWidth, cssHeight, isPortrait };
}
